module.exports = __webpack_public_path__ + "media/images/map-icons/mapbox-dark-a2abc92fe7fa9406998b7067366f315c.png";